module.exports = __webpack_public_path__ + "media/images/new_landing/people/martin-radimersky-389c26c0570506f14b234b66bd0114b3.jpg";